import { TextField } from 'office-ui-fabric-react';

const NotificationContentWrite = ({
  textContent,
  onChange,
  header,
  ariaLabel,
  multiline,
  autoAdjustHeight,
  styles,
}) => {
  const onChangeText = (_, value) => onChange(value);
  return (
    <div aria-label={ariaLabel}>
      <p className="notification-content-label">{header}</p>
      <TextField
        onChange={onChangeText}
        multiline={multiline}
        autoAdjustHeight={autoAdjustHeight}
        value={textContent}
        styles={styles}
      />
    </div>
  );
};

export { NotificationContentWrite };
